import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { http } from "../../service/http";
import { changeDateFormat } from "../../utils/dateFormat";
import axios from "axios";

// fetchEmployee - fetch all employees - or search employee
export const fetchEmployees = createAsyncThunk("employee/fetchEmployee", async (data, extra) => {
  const response = await http.get(`/employee${data ?? "/"}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (response.data.status === "success") {
    return response.data;
  }
});

//fetchMoreEmployees - fetch more employees - react infinity scroll
export const fetchMoreEmployees = createAsyncThunk("employee/fetchMoreEmployees", async (url, extra) => {
  const res = await axios.get(url, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (res.data.status === "success") {
    return res.data;
  }
});

// createEmployee - create new employee
export const createEmployee = createAsyncThunk("employee/createEmployee", async (employeeData, extra) => {
  const response = await http.post(`/employee/`, employeeData, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (response.data.status === "success") {
    //Create new attendance for new employee
    const attendanceData = {
      employee: response.data.data.id,
      date: changeDateFormat(new Date()),
      check_in_time: "09:00:00",
      check_out_time: "17:00:00",
      status: "absent",
      overtime_hours: 0,
      notes: "",
      extra_expense: 0,
      distance_km: 0,
    };

    extra.dispatch(createAttendance(attendanceData));
    return response.data;
  }
});

//updateEmployee - update a employee
export const updateEmployee = createAsyncThunk("employee/updateEmployee", async (data, extra) => {
  const response = await http.put(`/employee/${data.id}/`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (response.data.status === "success") {
    return response.data.data;
  }
});

// deleteEmployee - delete a particular employee
export const deleteEmployee = createAsyncThunk("employee/deleteEmployee", async (data, extra) => {
  const response = await http.delete(`/employee/${data}/`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (response.data.status === "success") {
    return data;
  }
});

// getEmployeeById - get particular employee by ID
export const getEmployeeById = createAsyncThunk("employee/getEmployeeById", async (data, extra) => {
  const response = await http.get(`/employee/${data.id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (response.data.status === "success") {
    return response.data.data;
  }
});

// fetchAttendances  - fetch all attendances
export const fetchAttendances = createAsyncThunk("employee/attendances", async (data, extra) => {
  const response = await http.get(
    `/employee/attendance${
      data?.date
        ? `?start_date=${data.date}&end_date=${data.date}${data?.employee ? `&employee_id=${data.employee}` : ""}`
        : "/"
    }`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );
  if (response.data.status === "success") {
    return response.data;
  }
});

//fetchMoreEmployees - fetch more employees - react infinity scroll
export const fetchMoreAttendances = createAsyncThunk("employee/fetchMoreAttendances", async (url, extra) => {
  const res = await axios.get(url, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (res.data.status === "success") {
    return res.data;
  }
});

// createAttendance - create attendance
export const createAttendance = createAsyncThunk("employee/createAttendance", async (data, extra) => {
  const response = await http.post("/employee/attendance/", data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (response.data.status === "success") {
    return response.data.data;
  }
});

// updateAttendance - update attendance based on employee id
export const updateAttendance = createAsyncThunk("employee/updateAttendance", async (data, extra) => {
  const response = await http.put(`/employee/attendance/${data.employee}/${data.id}/`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (response.data.status === "success") {
    return response.data.data;
  }
});

// create attendance by date / return all today's attendance
export const createAllAttendances = createAsyncThunk("employee/createAllAttendances", async (data, extra) => {
  const response = await http.post(`/employee/attendance/mark-all-attendance/`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (response.data.status === "success") {
    return response.data.data;
  }
});

// export const deleteAttendance = createAsyncThunk("employee/deleteAttendance", async (data, extra) => {
//   const IdByEmployee = extra
//     .getState()
//     .employee.attendances.find((attendance) => attendance.employee === data.employee).id;

//   if (IdByEmployee) {
//     const response = await http.delete(`/employee/attendance/${data.employee}/${IdByEmployee}/`, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     });
//     //Fix it after API change
//     return IdByEmployee;
//   }
// });

//Employee permission managment

//Fetch all permission groups
export const fetchAllPermissionGroup = createAsyncThunk("employee/fetchAllPermissionGroup", async (data, extra) => {
  const response = await http.get(`/employee_settings/permission-groups/`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (response.data.status === "success") {
    return response.data;
  }
});

//fetch more permission groups
export const fetchMorePermissionGroup = createAsyncThunk("employee/fetchMorePermissionGroup", async (url, extra) => {
  const response = await http.get(url, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (response.data.status === "success") {
    return response.data;
  }
});

//Create permission group
export const createPermissionGroup = createAsyncThunk("employee/createPermissionGroup", async (data, extra) => {
  const response = await http.post(`/employee_settings/permission-groups/`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (response.data.status === "success") {
    return response.data.data;
  }
});

//Update permission group
export const updatePermissionGroup = createAsyncThunk("employee/updatePermissionGroup", async (data, extra) => {
  const response = await http.put(`/employee_settings/permission-groups/${data.id}/`, data.data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (response.data.status === "success") {
    return response.data.data;
  }
});

//delete permission group
export const deletePermissionGroup = createAsyncThunk("employee/deletePermissionGroup", async (data, extra) => {
  const response = await http.delete(`/employee_settings/permission-groups/${data}/`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (response.data.status === "success") {
    return data;
  }
});

//Fetch permission groups
export const fetchPermissionGroups = createAsyncThunk("employee/fetchPermissionGroups", async (data, extra) => {
  const response = await http.get(`/employee_settings/permission-groups/${data}/permissions/`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  if (response.data.status === "success") {
    return response.data.data;
  }
});

//Add permission to sepecific group
export const addPermissionToGroup = createAsyncThunk("employee/addPermissionToGroup", async (data, extra) => {
  const response = await http.get(`/employee_settings/permissions-groups/${data.id}/permissions/`, data.data, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  if (response.data.status === "success") {
    return response.data.data;
  }
});

//Get permission of employee
export const getPermissionOfEmployee = createAsyncThunk("employee/getPermissionOfEmployee", async (data, extra) => {
  const response = await http.get(`/employee_settings/employee-permissions/${data}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  if (response.data.status === "success") {
    return response.data.data;
  }
});

//Assign permission group to employee
export const assignPermissionGroupToEmployee = createAsyncThunk(
  "employee/assignPermissionGroupToEmployee",
  async (data, extra) => {
    const response = await http.post(`/employee_settings/employee-permissions/${data.employee}/`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    if (response.data.status === "success") {
      return response.data.data;
    }
  }
);

//Delete permission group from employee
export const deletePermissionGroupFromEmployee = createAsyncThunk(
  "employee/deletePermissionGroupFromEmployee",
  async (data, extra) => {
    const response = await http.delete(`/employee_settings/employee-permissions/delete/${data}/`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    if (response.status === 204) {
      return data;
    }
  }
);

//Payhead operations

//fetch payhead details
export const fetchEmployeePaystructureDetails = createAsyncThunk(
  "employee/fetchEmployeePaystructureDetails",
  async (data, extra) => {
    const response = await http.get(`/employee/${data}/pay-structure/`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    if (response.data.status === "success") {
      return response.data.data;
    }
  }
);

//create payhead
export const createPayhead = createAsyncThunk("employee/createPayhead", async (data, extra) => {
  const response = await http.post(`/employee/${data.id}/pay-structure/`, data.data, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  if (response.data.status === "success") {
    return response.data.data;
  }
});

//update payhead
export const updatePayhead = createAsyncThunk("employee/updatePayhead", async (data, extra) => {
  const response = await http.put(`/employee/${data.id}/pay-structure/`, data.data, {
    headers: { Authorization: `bearer ${localStorage.getItem("token")}` },
  });
  if (response.data.status === "success") {
    return response.data.data;
  }
});

//Terminate payhead
export const deletePayhead = createAsyncThunk("employee/deletePayhead", async (data, extra) => {
  const response = await http.post(`/employee/${data.id}/pay-structure/terminate/`, data.data, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  if (response.data.status === "success") {
    return response.data.data;
  }
});

//Previous salary details
export const getPreviousSalaryDetails = createAsyncThunk("employee/getPreviousSalaryDetails", async (data, extra) => {
  const response = await http.get(`/employee/${data}/pay-structure/history/`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  if (response.data.status === "success") {
    return response.data.data;
  }
});

//Process employee salary
export const processEmployeeSalary = createAsyncThunk(
  "employee/processEmployeeSalary",
  async (data, { rejectWithValue }) => {
    try {
      const response = await http.post(`/employee/${data.id}/salary/`, data.data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (response.data.status === "success") {
        console.log(response.data.data, "this is the response data");
        return response.data.data;
      } else {
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error.message || "An error occurred");
    }
  }
);

//Get processed employee salary
export const getProcessedEmployeeSalary = createAsyncThunk("employee/getProcessEmployeeSalary", async (data, extra) => {
  const response = await http.get(`/employee/${data}/salary/`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  if (response.data.status === "success") {
    return response.data.data;
  }
});

//handle salary status change
export const changeSalaryStatus = createAsyncThunk("employee/changeSalaryStatus", async (data, extra) => {
  const response = await http.put(`/employee/${data?.id}/salary/status/`, data.data, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  if (response.data.status === "success") {
    return response.data.data;
  }
});

//Summay details and employee specific summary
export const fetchOverallSummary = createAsyncThunk("employee/overallSummary", async (data, extra) => {
  const response = await http.get(`employee/payroll/summary/${data ? data : ""}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });
  if (response.data.status === "success") {
    return response.data.data;
  }
});

//fetch employee calendar attendances
export const getEmployeeCalendarAttendance = createAsyncThunk("employee/calendarAttendance", async (data, extra) => {
  const response = await http.get(`/employee/attendance/employee/mark-days-attendance/${data?.id}/${data.data}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });

  if (response.data.status === "success") {
    return response.data.data;
  }
});

//create employee calendar attendance
export const createCalendarEmployeeAttendance = createAsyncThunk(
  "employee/createCalendarEmployeeAttendance",
  async (data, extra) => {
    const response = await http.post(
      `/employee/attendance/employee/mark-days-attendance/${data.id}/?month=${data.month}`,
      data.data,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      }
    );

    if (response.data.status === "success") {
      return response.data.data;
    }
  }
);

//bulk process employee salaries
export const bulkProcessEmployeeSalary = createAsyncThunk("employee/bulkProcessEmployeeSalary", async (data, extra) => {
  const response = await http.post("/employee/payroll/process/", {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });

  if (response.data.status === "success") {
    return response.data.data;
  }
});

//edit generated salary
export const updateProcessedEmployeeSalary = createAsyncThunk(
  "employee/updateProcessedEmployeeSalary",
  async (data, extra) => {
    const response = await http.put(`/employee/${data?.empId}/salary/${data.id}/`, data.data, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });

    if (response.data.status === "success") {
      return response.data.data;
    }
  }
);

//Business Holiday Settings / Pay Schedule
export const fetchBusinessHolidaySettings = createAsyncThunk(
  "employee/fetchBusinessHolidaySettings",
  async (data, extra) => {
    const response = await http.get("/employee/business_holiday/setting/", data, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });

    if (response.data.status === "success") {
      return response.data.data;
    }
  }
);

export const createBusinessHolidaySettings = createAsyncThunk(
  "employee/createBusinessHolidaySettings",
  async (data, extra) => {
    const response = await http.post("/employee/business_holiday/setting/", data, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });

    if (response.data.status === "success") {
      return response.data.data;
    }
  }
);

export const updateBusinessHolidaySettings = createAsyncThunk(
  "employee/updateBusinessHolidaySettings",
  async (data, extra) => {
    const response = await http.put(`/employee/business_holiday/setting/${data?.id}/`, data?.data, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });

    if (response.data.status === "success") {
      return response.data.data;
    }
  }
);

export const deleteBusinessHolidaySettings = createAsyncThunk(
  "employee/deleteBusinessHolidaySettings",
  async (data, extra) => {
    const response = await http.delete("/employee/business_holiday/setting/", data, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });

    if (response.data.status === "success") {
      return {};
    }
  }
);

//bulk salary export pdf
export const bulkSalaryPDFSlip = createAsyncThunk("employee/bulkSalaryPDFSlip", async (data, extra) => {
  const response = await http.post("/employee/salary/bulk_pay_slip_pdf/", data, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });

  return response;
});

//Advance salary API
export const payAdvanceSalary = createAsyncThunk("employee/payAdvanceSalary", async (data, extra) => {
  const response = await http.post(`employee/${data.id}/advance_salary/`, data.data, {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  });

  if (response.data.status === "success") {
    return response.data.data;
  }
});

// employee slice
const employeeSlice = createSlice({
  name: "employee",
  initialState: {
    employees: { data: [], next: "" },
    employeeById: [],
    attendances: { data: [], next: "" },
    permissionGroups: { data: [], next: "" },
    employeePermission: [],
    employeePaystructure: {},
    employeePreviousPaystructure: [],
    processedEmployeeSalary: [],
    overallSummary: {},
    employeeCalendarAttendance: {},
    businessHolidaySettings: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchEmployees.fulfilled, (state, action) => {
      return {
        ...state,
        employees: { data: action.payload.data, next: action.payload.next },
      };
    });
    builder.addCase(fetchMoreEmployees.fulfilled, (state, action) => {
      return {
        ...state,
        employees: { data: [...state.employees.data, ...action.payload.data], next: action.payload.next },
      };
    });
    builder.addCase(createEmployee.fulfilled, (state, action) => {
      return {
        ...state,
        employees: { data: [...state.employees.data, action.payload.data], next: action.payload.next },
      };
    });
    builder.addCase(updateEmployee.fulfilled, (state, action) => {
      return {
        ...state,
        employees: {
          ...state.employees,
          data: state.employees.data.map((employee) => (employee.id === action.payload.id ? action.payload : employee)),
        },
      };
    });
    builder.addCase(getEmployeeById.fulfilled, (state, action) => {
      return {
        ...state,
        employeeById: [action.payload],
      };
    });
    builder.addCase(deleteEmployee.fulfilled, (state, action) => {
      return {
        ...state,
        employees: {
          ...state.employees,
          data: state.employees.data.filter((employee) => employee.id !== action.payload),
        },
      };
    });
    builder.addCase(fetchAttendances.fulfilled, (state, action) => {
      return {
        ...state,
        attendances: { data: action.payload.data, next: action.payload.next },
      };
    });
    builder.addCase(fetchMoreAttendances.fulfilled, (state, action) => {
      return {
        ...state,
        attendances: { data: [...state.attendances.data, ...action.payload.data], next: action.payload.next },
      };
    });
    builder.addCase(createAttendance.fulfilled, (state, action) => {
      return {
        ...state,
        attendances: { ...state.attendances, data: [...state.attendances.data, action.payload] },
      };
    });
    builder.addCase(updateAttendance.fulfilled, (state, action) => {
      return {
        ...state,
        attendances: {
          ...state.attendances,
          data: state.attendances.data.map((attendance) =>
            attendance.id === action.payload.id ? action.payload : attendance
          ),
        },
      };
    });
    builder.addCase(createAllAttendances.fulfilled, (state, action) => {
      return {
        ...state,
        attendances: {
          data: action.payload,
          next: null,
        },
      };
    });
    // builder.addCase(deleteAttendance.fulfilled, (state, action) => {
    //   return {
    //     ...state,
    //     attendances: state.attendances.filter((attendance) => attendance.id !== action.payload),
    //   };
    // });
    builder.addCase(fetchAllPermissionGroup.fulfilled, (state, action) => {
      return {
        ...state,
        permissionGroups: { data: action.payload.data, next: action.payload.next },
      };
    });
    builder.addCase(fetchMorePermissionGroup.fulfilled, (state, action) => {
      return {
        ...state,
        permissionGroups: { data: [...state.permissionGroups.data, ...action.payload.data], next: action.payload.next },
      };
    });
    builder.addCase(createPermissionGroup.fulfilled, (state, action) => {
      return {
        ...state,
        permissionGroups: { data: [...state.permissionGroups.data, action.payload], next: state.permissionGroups.next },
      };
    });
    builder.addCase(updatePermissionGroup.fulfilled, (state, action) => {
      return {
        ...state,
        permissionGroups: {
          ...state.permissionGroups,
          data: state.permissionGroups.data.map((group) => (group.id === action.payload.id ? action.payload : group)),
        },
      };
    });
    builder.addCase(deletePermissionGroup.fulfilled, (state, action) => {
      return {
        ...state,
        permissionGroups: {
          ...state.permissionGroups,
          data: state.permissionGroups.data.filter((group) => group.id !== action.payload),
        },
      };
    });
    builder.addCase(getPermissionOfEmployee.fulfilled, (state, action) => {
      return {
        ...state,
        employeePermission: action.payload[0].group.permissions,
      };
    });
    builder.addCase(fetchEmployeePaystructureDetails.fulfilled, (state, action) => {
      return {
        ...state,
        employeePaystructure: action.payload,
      };
    });
    builder.addCase(getPreviousSalaryDetails.fulfilled, (state, action) => {
      return {
        ...state,
        employeePreviousPaystructure: action.payload,
      };
    });
    builder.addCase(processEmployeeSalary.fulfilled, (state, action) => {
      // Check if the payload is an object (single entry) and not an array
      let updatedSalary;
      if (action.payload && typeof action.payload === "object" && !Array.isArray(action.payload)) {
        // Assuming each salary entry has a 'month' property like '2025-03-01'
        const payloadMonth = action.payload.month;
        const existingIndex = state.processedEmployeeSalary.findIndex((salary) => salary.month === payloadMonth);
        console.log(existingIndex, payloadMonth, "this is the value of existing index");
        if (existingIndex >= 0) {
          // Replace the existing salary entry for that month
          updatedSalary = [...state.processedEmployeeSalary];
          updatedSalary[existingIndex] = action.payload;
        } else {
          // Append the new salary entry if no duplicate month is found
          updatedSalary = [...state.processedEmployeeSalary, action.payload];
        }
      } else {
        // If payload is an array or not as expected, just use it directly.
        updatedSalary = action.payload;
      }

      return {
        ...state,
        processedEmployeeSalary: updatedSalary,
      };
    });

    builder.addCase(changeSalaryStatus.fulfilled, (state, action) => {
      const updatedSalaryEntries = state.processedEmployeeSalary.map((salary) => {
        if (salary?.id === action.payload.id) {
          return action.payload;
        } else {
          return salary;
        }
      });

      return {
        ...state,
        processedEmployeeSalary: updatedSalaryEntries,
      };
    });
    builder.addCase(updateProcessedEmployeeSalary.fulfilled, (state, action) => {
      const updatedSalary = state.processedEmployeeSalary.map((salary) => {
        if (salary.id === action.payload.id) {
          return action.payload;
        } else {
          return salary;
        }
      });

      return {
        ...state,
        processedEmployeeSalary: updatedSalary,
      };
    });
    builder.addCase(getProcessedEmployeeSalary.fulfilled, (state, action) => {
      //single entry is coming as object instead of single entry in array
      const updatedSalary =
        action.payload && typeof action.payload === "object" && !Array.isArray(action.payload)
          ? [...state.processedEmployeeSalary, action.payload]
          : action.payload;

      return {
        ...state,
        processedEmployeeSalary: updatedSalary,
      };
    });
    builder.addCase(fetchOverallSummary.fulfilled, (state, action) => {
      return { ...state, overallSummary: action.payload };
    });
    builder.addCase(getEmployeeCalendarAttendance.fulfilled, (state, action) => {
      return { ...state, employeeCalendarAttendance: action.payload };
    });
    builder.addCase(createCalendarEmployeeAttendance.fulfilled, (state, action) => {
      return { ...state, employeeCalendarAttendance: action.payload.success };
    });
    builder.addCase(fetchBusinessHolidaySettings.fulfilled, (state, action) => {
      return { ...state, businessHolidaySettings: action.payload };
    });
    builder.addCase(createBusinessHolidaySettings.fulfilled, (state, action) => {
      return { ...state, businessHolidaySettings: action.payload };
    });
    builder.addCase(updateBusinessHolidaySettings.fulfilled, (state, action) => {
      return { ...state, businessHolidaySettings: action.payload };
    });
    builder.addCase(deleteBusinessHolidaySettings.fulfilled, (state, action) => {
      return { ...state, businessHolidaySettings: action.payload.data };
    });
  },
});

export default employeeSlice.reducer;
